import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';


const withTracker = (WrappedComponent) => {
  const HOC = class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    }

    componentDidMount() {
      const page = this.props.location.pathname;
      ReactGA.pageview(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        ReactGA.pageview(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;
